import {
  endsWith,
  trimEnd,
  split,
  find,
  eachRight,
  startsWith,
  join,
  dropRight
} from 'lodash'

import CareerMapperLanding from '../pages/career-mapper/landing'
import CareerMapperAbout from '../pages/career-mapper/about-you'
import CareerMapperData from '../pages/career-mapper/data'
import CareerMapperCareerPath from '../pages/career-mapper/career-path'
import CareerMapperDetail from '../pages/career-mapper/detail'
import CareerMapperRegister from '../pages/career-mapper/register'
import CareerMapperReport from '../pages/career-mapper/report'
import CareerMapperSharedReport from '../pages/career-mapper/shared-report'

const routes = [
  {
    name: 'Tell us about yourself',
    exact: true,
    path: '/',
    component: CareerMapperLanding
  },
  {
    name: 'Tell us about yourself',
    exact: true,
    path: '/career-explorer/about-you',
    component: CareerMapperAbout
  },
  {
    name: 'Career Explorer data',
    exact: true,
    path: '/career-explorer/data',
    component: CareerMapperData
  },
  {
    exact: true,
    name: 'Your career path',
    path: '/career-explorer/career-path',
    component: CareerMapperCareerPath
  },
  {
    name: 'Your current skillset',
    path: '/career-explorer/career-path/detail/:job',
    component: CareerMapperDetail
  },
  {
    name: 'Your future awaits',
    path: '/career-explorer/register',
    component: CareerMapperRegister
  },
  {
    exact: true,
    name: 'Your career plan',
    path: '/career-explorer/report',
    component: CareerMapperReport
  },

  // Shared Report
  {
    exact: true,
    name: 'Your Career Path',
    path: '/report/:uuid/:suid',
    component: CareerMapperSharedReport
  }
]

export default routes
export function getRouteDefinition(path) {
  const noSlashPath = endsWith(path, '/') ? trimEnd(path, '/') : path
  const splitPath = split(noSlashPath, '/')

  let route = find(routes, r => {
    const noSlashRoutePath = endsWith(r.path, '/')
      ? trimEnd(r.path, '/')
      : r.path
    const splitRouterPath = split(noSlashRoutePath, '/')
    let dropRoute = 0
    eachRight(splitRouterPath, rp => {
      if (startsWith(rp, ':')) dropRoute++
    })

    const parsedPath = join(dropRight(splitPath, dropRoute), '/')
    const parsedRoutePath = join(dropRight(splitRouterPath, dropRoute), '/')

    return parsedRoutePath === parsedPath
  })

  return route || { name: 'Career Explorer' }
}
